export const AttachmentTypes = [
  'computer',
  'trello',
  'link',
  'google-drive',
  'dropbox',
  'box',
  'onedrive',
];
